require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./humanits-digitales-eddh-2-3-4-5.json") })
        }
      }, "path---humanits-digitales-eddh-2-3-4-5");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---humanits-digitales-eddh-2-3-4-5!./.cache/json/humanits-digitales-eddh-2-3-4-5.json
// module id = 461
// module chunks = 231608221292675